var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGotEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "saiki-mail",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#saiki-mail:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#saiki-mail.animated #saiki-Mail--2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideDown, 3s Infinite linear heartbeat;\n      animation-delay: 0s, 1s;\n    }\n\n    svg#saiki-mail.animated #saiki-Mailbox--2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    @keyframes slideDown {\n      0% {\n        opacity: 0;\n        transform: translateY(-30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    @keyframes heartbeat {\n      0% {\n        transform: scale(1);\n      }\n\n      10% {\n        transform: scale(1.1);\n      }\n\n      30% {\n        transform: scale(1);\n      }\n\n      40% {\n        transform: scale(1);\n      }\n\n      50% {\n        transform: scale(1.1);\n      }\n\n      60% {\n        transform: scale(1);\n      }\n\n      100% {\n        transform: scale(1);\n      }\n    }\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: inherit;\n      }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "saiki-background-simple--2",
    className: "animable",
    style: {
      transformOrigin: "248.466px 269.015px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.35,279.68q-.5-2.61-1.05-5.16c-9.16-43.09-27.61-87.59-60.5-118-14.25-13.15-31.48-23.2-50.68-26.82-23.44-4.41-47.81,1.7-69.35,12s-40.87,24.52-60.83,37.58c-12.89,8.43-26.52,16.55-41.73,19-18.21,2.93-36.84-2.57-55.21-.82-28.8,2.74-54.18,24.22-64.56,51.23s-6.62,58.36,7.06,83.86S91,377.91,116.84,391c35.75,18.16,78,23.84,116.9,14,19-4.8,37.34-13.2,56.9-13.55,24.26-.43,47,11.57,71,14.89,22.56,3.11,46.62-2,64.57-16C459.5,364.34,458.56,317.14,451.35,279.68Z",
    style: {
      fill: "rgba(245, 198, 100, .2)",
      transformOrigin: "248.466px 269.015px"
    },
    id: "elgtiafjb7se",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki-Clouds--2",
    className: "animable",
    style: {
      transformOrigin: "232.234px 264.456px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.21,174c-3.25-1.78-4.73-.3-5.91-1.78s3.25-5.32-5.62-9.16c0,0-.59-8.28-12.71-8.57s-8.87,8.27-12.12,10.34-4.14-1.18-7.39.89-1.77,6.21-4.43,6.8-6.21-2.66-9.46-.59-3.25,3.84-4.73,3.84-4.44-1.18-6.21,0-3.84,2.66-3.84,2.66h74.79S384.46,175.72,381.21,174Z",
    style: {
      fill: "rgba(255, 255, 255, .5)",
      transformOrigin: "346.239px 166.456px"
    },
    id: "elkodyza6zrhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,370c-3.26-1.78-4.73-.3-5.92-1.78s3.25-5.32-5.61-9.16c0,0-.59-8.28-12.71-8.57s-8.87,8.27-12.12,10.34-4.14-1.18-7.39.89-1.78,6.21-4.44,6.8-6.21-2.66-9.46-.59-3.25,3.84-4.73,3.84-4.43-1.18-6.21,0-3.84,2.66-3.84,2.66h74.79S257.8,371.72,254.55,370Z",
    style: {
      fill: "rgba(255, 255, 255, .5)",
      transformOrigin: "219.571px 362.456px"
    },
    id: "elsup5e5v34q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12,337c-5.09-2.77-7.4-.46-9.25-2.77s5.08-8.33-8.79-14.34c0,0-.92-12.95-19.89-13.41s-13.87,12.95-19,16.19-6.47-1.85-11.56,1.38-2.78,9.72-6.94,10.64-9.71-4.16-14.8-.92-5.09,6-7.4,6-6.94-1.85-9.71,0-6,4.16-6,4.16h117S199.2,339.81,194.12,337Z",
    style: {
      fill: "rgba(255, 255, 255, .5)",
      transformOrigin: "139.371px 325.199px"
    },
    id: "el9vhc4oc2qqu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki-Mail--2",
    className: "animable",
    style: {
      transformOrigin: "213.429px 130.85px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.52,71.57c-34.91,0-63.3,25.47-64.29,57.22l-27.51,15.07-14.46-13.74-20.88,31.7-14.54-.62,7.46,28.93.65-23.81,10.29,1.93,17-17.89,17.35,13.74,27.19-17c7.84,24.44,32.49,42.3,61.72,42.3,35.53,0,64.34-26.38,64.34-58.92S283.05,71.57,247.52,71.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "208.84px 130.85px"
    },
    id: "el8wct3as8he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.62,
    y: 92.18,
    width: 127.72,
    height: 77.7,
    rx: 5.83,
    style: {
      fill: "rgb(245, 198, 100)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "246.48px 131.03px"
    },
    id: "elq17xccn58s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,129.09l58.76-29.73V98a5.83,5.83,0,0,0-5.83-5.83H188.45A5.83,5.83,0,0,0,182.62,98v1.61l57.69,29.61A12.59,12.59,0,0,0,251.58,129.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "246.48px 111.329px"
    },
    id: "elqjblgts2shq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcrb89hp6b0n"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 305.97,
    cy: 108.21,
    r: 13.11,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.97px 108.21px",
      transform: "rotate(-9.26deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,115.73a2.1,2.1,0,0,1-.47-1.46V102.6L302.42,104a1.07,1.07,0,0,1-.61.18,1,1,0,0,1-.8-.37,1.19,1.19,0,0,1-.34-.85,1.15,1.15,0,0,1,.62-1l4.19-2.47a2,2,0,0,1,1-.31,1.46,1.46,0,0,1,1.15.51,2.16,2.16,0,0,1,.44,1.44v13.22a2,2,0,0,1-.47,1.39,1.55,1.55,0,0,1-1.2.52A1.48,1.48,0,0,1,305.19,115.73Z",
    style: {
      fill: "rgb(245, 198, 100)",
      transformOrigin: "304.372px 107.721px"
    },
    id: "elyezf2lxusb9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "saiki-Mailbox--2",
    className: "animable",
    style: {
      transformOrigin: "245.582px 297.385px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.5,281.76s39.5,59.5,49,60.5,39.5-30,39.5-30l-8.5-2L235.19,329.4S211,299.7,189.74,277Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "227.75px 309.642px"
    },
    id: "elto9vmhlkte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53,264s7.92.34,7.58,3.79,0,12.75-2.07,14.48-5.17,2.41-5.86-1S190.53,264,190.53,264Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "194.032px 273.85px"
    },
    id: "eld5l3y7dhu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,280.23s-.35,10.34-1,11.37-5.52,4.83-8.62,4.14-2.07-3.79-2.07-5.51V263h11.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "182.548px 279.412px"
    },
    id: "elixlqq57cc8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26,284s-2.41,4.48-.35,7.93,7.93,3.45,10.35,1.72.68-4.13-1.38-4.82-4.83-2.42-4.83-4.48S173.29,282.64,172.26,284Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "177.257px 288.84px"
    },
    id: "elxur4py7uvqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,277.46c0,2.36.4,6.32,2.26,8,2.1,1.85,11.76,2,16-.83s1.42-7.7-1.79-7.39c-2.66.26-5.51-.39-8.21-.73-1.52-.19-6.88-1.38-7.93-.27a1.73,1.73,0,0,0-.29,1.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "180.593px 281.291px"
    },
    id: "elfb6jhyrngg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2,268.92c-.33,2.38-.48,6.4,1.47,8.14,2.21,2,13.66,2.56,19.07-.08s2.84-7.71-1-7.54c-3.19.13-6.48-.67-9.62-1.14-1.77-.26-8-1.71-9.37-.64a1.76,1.76,0,0,0-.53,1.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "180.917px 273.018px"
    },
    id: "eltmk9oqj2zy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.87,257.14c-.85,2.25-1.89,6.14-.37,8.27,1.73,2.41,12.76,5.51,18.61,4.13s4.49-6.89.69-7.58c-3.14-.57-6.17-2.08-9.13-3.23-1.67-.65-7.38-3.43-9-2.7a1.74,1.74,0,0,0-.77,1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "180.401px 262.895px"
    },
    id: "el90izrpt09q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "261.57 429.96 293.07 312.2 303.73 312.2 270.29 430.93",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "282.65px 371.565px"
    },
    id: "el9p02pox9tx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "282.43 418.7 312.94 311.72 303.73 312.2 270.29 430.93",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "291.615px 371.325px"
    },
    id: "elnw1sal6ahl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.5,
    y1: 428.99,
    x2: 280.91,
    y2: 424.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "280.205px 426.52px"
    },
    id: "elgsjb6skwimo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,339.86s3.45,5.17,7.59,5.86S296,311.94,296,311.94L278.07,314Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "268.25px 328.835px"
    },
    id: "ellyntduciiyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,284.58s8.24-68.33,26.66-92.08c20.13-26,60.58-4.84,52.34,36.83-6.32,32-24.72,89.17-24.72,89.17Z",
    style: {
      fill: "rgb(245, 198, 100)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "252.756px 249.807px"
    },
    id: "elieyyd6ei90r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.84,183.78l107.68,34a23.93,23.93,0,0,1,9.42,5.54c6.79,6.54,16.92,20.61,8.41,41.36a176.37,176.37,0,0,1-27.62,45.07L267,318.5l20.84-80.45S297.52,202.68,271.84,183.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "333.8px 251.14px"
    },
    id: "ellan5xk0bmir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "333.45px 286.678px"
    },
    id: "el7jgq1614nsj",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.33,278.43c-25.9,12.14-39.75,10-46.64,6.5L267,318.5l102.74-8.72a176.37,176.37,0,0,0,27.62-45.07,44.69,44.69,0,0,0,2.54-8.38C374.93,250.45,355.13,263.06,322.33,278.43Z",
    style: {
      fill: "rgb(245, 198, 100)",
      transformOrigin: "333.45px 286.678px"
    },
    id: "elk1prdxfuwwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt4d13zziern"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.33,278.43c-25.9,12.14-39.75,10-46.64,6.5L267,318.5l102.74-8.72a176.37,176.37,0,0,0,27.62-45.07,44.69,44.69,0,0,0,2.54-8.38C374.93,250.45,355.13,263.06,322.33,278.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "333.45px 286.678px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.84,183.78l107.68,34a23.93,23.93,0,0,1,9.42,5.54c6.79,6.54,16.92,20.61,8.41,41.36a176.37,176.37,0,0,1-27.62,45.07L267,318.5l20.84-80.45S297.52,202.68,271.84,183.78Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "333.8px 251.14px"
    },
    id: "elbsf97fpwjmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,193.92,315.5,246.54c-2.87.47-5.67,2.84-7.06,6.33-1.92,4.82-.43,9.95,3.33,11.45s8.37-1.2,10.29-6c1.58-4,.85-8.14-1.56-10.33l11.86-40.52,16.54,5.64,4.52-11.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "330.511px 229.327px"
    },
    id: "elwehis68970l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,240.54s7.52,8.28,7.9,12.41-6.39,15-6.39,15,13.91,8.65,27.07,2.63S277.46,239,277.46,239s-15.79,7.52-21.81,7.52S229.33,240.54,229.33,240.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "253.395px 255.855px"
    },
    id: "ely3a37fmchk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.91,270.62c3.63-1.66,6.74-4.81,9.35-8.49a4.18,4.18,0,0,0-3.33-3.16c-7.9-1.51-16.17,7.14-16.17,7.14a25.1,25.1,0,0,0-1.34,6.6A24.45,24.45,0,0,0,257.91,270.62Z",
    style: {
      fill: "rgb(245, 198, 100)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.84px 265.774px"
    },
    id: "el5xh8p31k6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,263.86a27.44,27.44,0,0,1-12.1-3.34c-1.83,3.86-4.07,7.47-4.07,7.47s13.91,8.65,27.07,2.63a23.86,23.86,0,0,0,8.84-7.79C263.66,263.17,253.62,264.17,247,263.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.785px 266.635px"
    },
    id: "ela1qzi59k8bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.65,246.56c-6,0-26.32-6-26.32-6a58.25,58.25,0,0,1,6.56,8.83c5,2,13.79,5.09,20.89,5.09A32.48,32.48,0,0,0,274,249.35,88.1,88.1,0,0,0,277.46,239S261.67,246.56,255.65,246.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "253.395px 246.74px"
    },
    id: "elavcu2yb4ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.15,229.26s2.26-7.89,8.65-8.65,8.27,3.76,8.27,3.76S259,224.37,254.15,229.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.61px 224.892px"
    },
    id: "elc8qhpiu7p87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.57,
    y1: 236.78,
    x2: 281.97,
    y2: 240.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "277.27px 238.475px"
    },
    id: "elstpkm9ifopr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.59,221.7c-.47,2.65-1.68,4.66-2.71,4.48s-1.46-2.48-1-5.14,1.69-4.67,2.71-4.49S244.07,219,243.59,221.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.739px 221.365px"
    },
    id: "el5gpgvpdl33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.65,219.86s-.37-4.51,9.4-4.51,11.66-1.13,7.9-6S253.4,207.08,255.65,219.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.092px 213.458px"
    },
    id: "elfwfiuyuaclg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.89,206.33s-.75-6.4-6.76-6.4-9.41,7.15-9.78,4.89,1.88-10.15,10.15-10.9S251.89,206.33,251.89,206.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.693px 200.11px"
    },
    id: "elwh8x9enu7ui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.32,201.11a42.37,42.37,0,0,1,2.9,12.67c2.4,27.43-22,102.2-22,102.2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "286.303px 258.545px"
    },
    id: "el5avfqsg25vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,190.11a14.67,14.67,0,0,1,5.53,4.4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "287.635px 192.31px"
    },
    id: "el4v05dux548i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,302.8c-2.38,3.58-4,6-4,6",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "367.82px 305.8px"
    },
    id: "el0hlf4esatgz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,217.21s18.18,10.29,20.58,25.38-3.43,23-6.86,31.21c-2,4.71-8.77,15.5-14.22,23.86",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "384.022px 257.435px"
    },
    id: "el1bfhrfpu7tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,275.66s5.44,5.43,17.66,4.07C249.42,279.73,237.2,285.16,231.76,275.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "240.59px 278.467px"
    },
    id: "elsfip99rgtvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94,271.27s31.83-16.69,89.93-6.46a10.25,10.25,0,0,0,11.86-8.29l.84-4.69a10.25,10.25,0,0,0-5.89-11.16c-15.43-6.93-51.33-26.15-70.2-61.77Z",
    style: {
      fill: "rgb(245, 198, 100)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "173.335px 225.085px"
    },
    id: "elsc5fsivjxri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,198.24s15.54,24.38,41.34,33.21",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "171.04px 214.845px"
    },
    id: "el346yev143g2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,240.67a176.42,176.42,0,0,1-25.91-14.46c2.71,8.66,3.49,21.75-7.72,35.54a216.11,216.11,0,0,1,26.82,3.06,10.25,10.25,0,0,0,11.86-8.29l.84-4.69A10.25,10.25,0,0,0,218.68,240.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "204.89px 245.587px"
    },
    id: "elte0ypg1qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell5yn4fvx8fq"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.21,
    cy: 222.66,
    rx: 55,
    ry: 21.2,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "127.21px 222.66px",
      transform: "rotate(-72.64deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltxy66lslab"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.97,
    cy: 222.27,
    rx: 49.48,
    ry: 17.77,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "125.97px 222.27px",
      transform: "rotate(-72.64deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,212.63l-9.3-.49-7,23.82,7.39,5.33a133.66,133.66,0,0,0,5.12-13.71A134.49,134.49,0,0,0,146.69,212.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.54px 226.715px"
    },
    id: "elp04rjf0vtf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,225.22c-1.92,6.58-5.27,11.39-7.49,10.74s-2.45-6.5-.53-13.08,5.28-11.39,7.49-10.74S139.84,218.65,137.92,225.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "133.908px 224.05px"
    },
    id: "elgtq4f5e85tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,344.34c-5.17-2.41-47.57-77.9-50-82s-1.72-10,.69-15.51,2.41-15.86,1-17.93-5.63-4.18-5.63-4.18.81-1,2.53-3.05,5.86-.69,5.86-.69c3.1-2.42,5.87,1.52,5.87,1.52,3.45-2.07,5.16,1.92,5.16,1.92a8,8,0,0,1,3.45,1c2.87,1.86,2.41,10,2.41,10s3.1.69,3.79,2.76a17.12,17.12,0,0,1-.69,10c-1.38,3.45-10,13.79-10,13.79l42.74,73.42",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "220.92px 282.267px"
    },
    id: "elvzna0uioohd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,221s4.95,3.19,4.95,6a54.13,54.13,0,0,0,.55,6.48",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "201.55px 227.24px"
    },
    id: "el1gi42hnbjpz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,222.47s3,3.15,3.15,5,.56,7.59.56,7.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "206.525px 228.765px"
    },
    id: "elr02fqbhgh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,224.39a9.83,9.83,0,0,1,1.69,5.12,53.64,53.64,0,0,0,.37,5.74",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "210.86px 229.82px"
    },
    id: "elckck4jcpro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,235.42s1.39,8.9.83,10.76",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "216.171px 240.8px"
    },
    id: "elj9ac0egwqmr",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "saiki-clip-path--2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.84,183.78l107.68,34a23.93,23.93,0,0,1,9.42,5.54c6.79,6.54,16.92,20.61,8.41,41.36a176.37,176.37,0,0,1-27.62,45.07L267,318.5l20.84-80.45S297.52,202.68,271.84,183.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotEmail);
export default __webpack_public_path__ + "static/media/gotEmail.2e4233cecc64475e2d2c6e794b2dc86a.svg";
export { ForwardRef as ReactComponent };